import { NextIntlClientProvider } from "next-intl"
import "../styles/globals.css"
import "../styles/colors.css"
import type { AppProps } from "next/app"
import { Bounce, ToastContainer } from "react-toastify"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import "react-toastify/dist/ReactToastify.css"
import styles from "../styles/components/toast.module.scss"
import Matomo from "../src/tracking/matomo"
import { GoogleTagManager } from "@next/third-parties/google"
import { useRouter } from "next/router"
import { IntlErrorCode } from "use-intl"
import Head from "next/head"

export default function App({ Component, pageProps }: AppProps) {
  // const matomoInitialized = useRef(false)
  // const MATOMO_URL = process.env.NEXT_PUBLIC_MATOMO_URL
  // const MATOMO_SITE_ID = process.env.NEXT_PUBLIC_MATOMO_SITE_ID
  const router = useRouter()
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 20 * 1000,
      },
    },
  })
  function onError(error) {
    if (error.code === IntlErrorCode.MISSING_MESSAGE) {
      // Missing translations are expected and should only log an error
      console.error(error)
    } else {
      // Other errors indicate a bug in the app and should be reported
      // reportToErrorTracking(error)
    }
  }

  function getMessageFallback({ namespace, key, error }) {
    const path = [namespace, key].filter((part) => part != null).join(".")

    if (error.code === IntlErrorCode.MISSING_MESSAGE) {
      return path + " is not yet translated"
    } else {
      return "Dear developer, please fix this message: " + path
    }
  }
  // useEffect(() => {
  //   if (MATOMO_URL && MATOMO_SITE_ID && matomoInitialized.current === false) {
  //     init({
  //       url: MATOMO_URL,
  //       siteId: MATOMO_SITE_ID,
  //       onRouteChangeComplete: path => {
  //         console.log(`route changed ${path}`)
  //         push(["Route change", path])
  //       }
  //     })
  //   }
  //   return () => {
  //     matomoInitialized.current = true
  //   }
  // }, [])
  const contextClass = {
    success: styles.successToast,
    error: styles.errorToast,
    info: styles.infoToast, // warning: "bg-orange-400",
    // default: "bg-indigo-600",
    // dark: "bg-white-600 font-gray-300",
  }

  return (
    <>
      <Head>
        <script>
          {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '4076895502445142');
fbq('track', 'PageView');`}
        </script>
        <noscript>
          <img
            alt={"meta-pixel"}
            height="1"
            width="1"
            style={{ display: "none" }}
            src="https://www.facebook.com/tr?id=4076895502445142&ev=PageView&noscript=1"
          />
        </noscript>
      </Head>
      <Matomo />
      <GoogleTagManager gtmId="GTM-WVCPVCG4" />
      <NextIntlClientProvider
        getMessageFallback={getMessageFallback}
        onError={onError}
        locale={router.locale || "de"}
        timeZone="Europe/Vienna"
        messages={pageProps.messages}
      >
        <QueryClientProvider client={queryClient}>
          <Component {...pageProps} />
          <ToastContainer
            // toastClassName={(context) =>
            //   contextClass[context?.type]} position="bottom-center" autoClose={4000} hideProgressBar={false} newestOnTop={false}
            closeOnClick
            rtl={false}
            position={"bottom-center"}
            pauseOnFocusLoss={false}
            draggable
            theme="light"
            transition={Bounce}
          />
        </QueryClientProvider>
      </NextIntlClientProvider>
    </>
  )
}
